import React, { lazy } from 'react';
import { MessageCircleIcon, StarIcon } from 'lucide-react';
export function TestimonialsSection() {
  const videos = ['https://cdn.magicpatterns.com/uploads/hXxBkXZdkKMc9HZkUNXXrZ/test%201%20.mp4', 'https://cdn.magicpatterns.com/uploads/rrvBCRxjWZnEyv1jz83DKM/test%202.mp4', 'https://cdn.magicpatterns.com/uploads/dS2tgTn49tUkrVF8b9k8BV/test%203.mp4'];
  const textReviews = [{
    initials: 'PD',
    color: 'bg-blue-600',
    name: 'Pablo Díaz',
    time: 'hace 2 horas',
    text: 'Todo está paso a paso. Lo descargué y ese mismo día armé mi primer tablero de control.'
  }, {
    initials: 'MG',
    color: 'bg-emerald-600',
    name: 'Mónica Gutierrez',
    time: 'hace 5 horas',
    text: 'El pack vale oro. El simulador fue una sorpresa, súper útil para practicar sin miedo.'
  }, {
    initials: 'JR',
    color: 'bg-indigo-600',
    name: 'Julián Ramirez',
    time: 'hace 1 día',
    text: 'Trabajo solo y esto me agilizó un montón. Diagramas rápidos de entender y que no fallan.'
  }, {
    initials: 'CV',
    color: 'bg-purple-600',
    name: 'Carla Vasquez',
    time: 'hace 1 día',
    text: 'Soy mujer y siempre pensé que la electricidad industrial era complicada. Con esta guía entendí todo perfecto.'
  }, {
    initials: 'MO',
    color: 'bg-orange-600',
    name: 'Matías Ortega',
    time: 'hace 2 días',
    text: 'Lo compré para mejorar mis servicios y realmente funciona. Los circuitos están probados.'
  }, {
    initials: 'RI',
    color: 'bg-teal-600',
    name: 'Rodrigo Iglesias',
    time: 'hace 3 días',
    text: 'Me ayudó a profesionalizar mi trabajo. Los clientes ahora me piden cosas que antes no me animaba a aceptar.'
  }, {
    initials: 'NR',
    color: 'bg-red-600',
    name: 'Nicolás Ramirez',
    time: 'hace 4 días',
    text: 'Siempre quise arrancar en automatización pero no sabía por dónde empezar. Con esto armé mi primer arranque estrella-triángulo en unos días.'
  }, {
    initials: 'AS',
    color: 'bg-cyan-600',
    name: 'Andrés Sosa',
    time: 'hace 5 días',
    text: 'Este material me fue de muchísima ayuda a la hora de calcular motores y saber cuánto cobrar. ¡Ya tengo muchos más trabajos!'
  }];
  return <section className="bg-[#0D1117] py-10 px-4 border-y border-white/10" data-id="element-396">
      <div className="max-w-[900px] mx-auto" data-id="element-397">
        <h2 className="text-[26px] text-center font-bold text-brand-black mb-10 leading-[1.2] heading-underline flex items-center justify-center gap-2" data-id="element-398">
          <MessageCircleIcon className="w-6 h-6 text-primary" data-id="element-399" />
          LO QUE DICEN PERSONAS COMO TÚ
        </h2>

        {/* Video Testimonials */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mb-8" data-id="element-400">
          {videos.map((videoSrc, idx) => <div key={`vid-${idx}`} className="bg-brand-black-light border border-white/10 rounded-xl p-4 shadow-sm flex flex-col items-center" data-id="element-401">
              <div className="flex text-primary mb-4" data-id="element-402">
                <StarIcon className="w-4 h-4 fill-current" data-id="element-403" />
                <StarIcon className="w-4 h-4 fill-current" data-id="element-404" />
                <StarIcon className="w-4 h-4 fill-current" data-id="element-405" />
                <StarIcon className="w-4 h-4 fill-current" data-id="element-406" />
                <StarIcon className="w-4 h-4 fill-current" data-id="element-407" />
              </div>
              <div className="w-full rounded-lg overflow-hidden border border-white/5 bg-black aspect-[9/16]" data-id="element-408">
                <video controls playsInline className="w-full h-full object-cover" preload="none" data-id="element-409">
                  <source src={videoSrc} type="video/mp4" data-id="element-410" />
                  Tu navegador no soporta el elemento de video.
                </video>
              </div>
            </div>)}
        </div>

        {/* Text Testimonials (Facebook Style without actions) */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4" data-id="element-411">
          {textReviews.map((review, idx) => <div key={`txt-${idx}`} className="bg-brand-black-light border border-primary/30 rounded-lg p-4 shadow-sm flex flex-col" data-id="element-412">
              <div className="flex items-center gap-3 mb-3" data-id="element-413">
                <div className={`w-10 h-10 rounded-full ${review.color} flex items-center justify-center text-white font-bold text-sm flex-shrink-0`} data-id="element-414">
                  {review.initials}
                </div>
                <div data-id="element-415">
                  <div className="font-bold text-brand-black text-[15px] leading-tight" data-id="element-416">
                    {review.name}
                  </div>
                  <div className="flex items-center gap-1 text-xs text-dark-gray mt-0.5" data-id="element-417">
                    <span data-id="element-418">{review.time}</span>
                    <span data-id="element-419">·</span>
                    <span className="flex text-primary" data-id="element-420">
                      <StarIcon className="w-3 h-3 fill-current" data-id="element-421" />
                      <StarIcon className="w-3 h-3 fill-current" data-id="element-422" />
                      <StarIcon className="w-3 h-3 fill-current" data-id="element-423" />
                      <StarIcon className="w-3 h-3 fill-current" data-id="element-424" />
                      <StarIcon className="w-3 h-3 fill-current" data-id="element-425" />
                    </span>
                  </div>
                </div>
              </div>
              <p className="text-white text-[15px] leading-relaxed" data-id="element-426">
                "{review.text}"
              </p>
              {review.name === 'Pablo Díaz' && <div className="mt-4 rounded-lg overflow-hidden border border-white/10" data-id="element-427">
                  <img loading="lazy" src="https://cdn.magicpatterns.com/uploads/cjrDd75N8ELtmFBu8u9sim/test_4.png" alt="Testimonio de Pablo" className="w-full h-auto block" data-id="element-428" />
                </div>}
            </div>)}
        </div>
      </div>
    </section>;
}